module.exports = __webpack_public_path__ + "img/shuixi03.d22314c3.png";